import { render } from "./Compania.vue?vue&type=template&id=f2859eb2&scoped=true"
import script from "./Compania.vue?vue&type=script&lang=js"
export * from "./Compania.vue?vue&type=script&lang=js"

import "../formulario.css?vue&type=style&index=0&lang=css&external"
import "./Compania.vue?vue&type=style&index=1&id=f2859eb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2859eb2"]])

export default __exports__